import Router from 'vue-routes-generator'
import OrganizarEmisoras from './App.vue'
import OpcionB from './paginas/organizar/organizar.vue'
import MainStore from '../../core/vue/store/stores'
import Store from './store'

export default {
	install: (Vue) => {
		Router.route('/main').child('organizar-emisoras', {
			name: 'Organizar emisoras',
			component: OrganizarEmisoras
		})

		Router.route('/main').child('organizar-emisoras').child('organizar', {
			name: 'Organizar emisoras',
			component: OpcionB
		})

		Router.route('/main').child('organizar-emisoras').child('', {
			redirect: '/main/organizar-emisoras/organizar'
		})

		MainStore.registerModule(['organizar-emisoras'], Store)
	}
}



// WEBPACK FOOTER //
// ./src/modulos/organizar-emisoras/vue/index.js